import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgNz = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#0052B4",
      d: "M0 11.995 12 0c6.627 0 12 5.373 12 12 0 6.514-5.19 11.816-11.661 11.995h-.678C5.191 23.816 0 18.515 0 12z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "M12 0C5.373 0 0 5.373 0 12h1.566l1.593-.637L4.697 12h1.566V8.475L9.787 12H12l-.36-.998.36-.479v-.736L8.475 6.262H12V4.697l-.553-1.566L12 1.566z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M7.735 6.258 12 10.523V12L6.263 6.258z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "m17.894 4.299.003-.01-.005.005zm0 0-.527 1.63h-1.72l1.392 1.004-.53 1.64 1.388-1.017 1.392 1.013-.54-1.632 1.393-1.007h-1.72zm2.346 5.029.53-1.64.53 1.635h1.72l-1.392 1.008.534 1.636-1.392-1.012-1.387 1.017.53-1.64-1.393-1.004zm-5.756.478.53-1.636.53 1.632h1.72l-1.392 1.007.534 1.641-1.392-1.012-1.388 1.012.53-1.636-1.392-1.008zm2.771 6.08.53-1.636.529 1.631h1.72l-1.392 1.008.534 1.64-1.392-1.012-1.387 1.013.53-1.636-1.393-1.008h1.72Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M6.07 1.565A12.06 12.06 0 0 0 1.564 6.07V12h3.132V4.698H12V1.565zM17.634 6.29l.263-.815.267.815h.858l-.694.507.267.815-.698-.506-.694.506.267-.815-.698-.507zm2.869 3.399.262-.816.005.005.267.816h.858l-.694.506.268.815-.704-.51-.693.506.267-.816-.699-.506zm-5.756.483.262-.82h.005l.267.82h.853l-.694.501.268.82-.699-.506-.694.507.268-.82-.699-.502zm2.77 6.079.262-.82.268.82h.857l-.693.502.262.82-.694-.506-.693.506.267-.82-.699-.502z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgNz;